__turbopack_context__.v({
  "body": "_2rZh4W_body",
  "footnote": "_2rZh4W_footnote",
  "group": "_2rZh4W_group",
  "groupTitle": "_2rZh4W_groupTitle",
  "rowAlready": "_2rZh4W_rowAlready",
  "rowCheck": "_2rZh4W_rowCheck",
  "rowDate": "_2rZh4W_rowDate",
  "rowDetails": "_2rZh4W_rowDetails",
  "rowItem": "_2rZh4W_rowItem",
  "rowOff": "_2rZh4W_rowOff",
  "rows": "_2rZh4W_rows",
  "submitError": "_2rZh4W_submitError",
});
